import { Component } from '@angular/core';

@Component({
  selector: 'app-main-claim-headers',
  templateUrl: './main-claim-headers.component.html',
  styleUrls: ['./main-claim-headers.component.css'],
})
export class MainClaimHeadersComponent {}
